import { render, staticRenderFns } from "./HistoricoExclusoesBoletins.vue?vue&type=template&id=a363323e&"
import script from "./HistoricoExclusoesBoletins.vue?vue&type=script&lang=js&"
export * from "./HistoricoExclusoesBoletins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports